// dependencies
import React from "react";

// components
import ViewFieldHistory from "./ViewFieldHistory";

const FieldHistory = () => {
	return <ViewFieldHistory />;
};

export default FieldHistory;
